import { IonModal, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent, IonItem, IonSearchbar, IonSpinner, IonCard, IonItemDivider, IonLabel, IonItemOption, IonItemOptions, IonItemSliding } from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from 'context/app.context';
import { getDomain, getDomainStorage, setDomainStorage, updateDomainStorage } from 'misc/utils';
import { Domain } from 'models/domain.model';


const DomainCode = (props: { CloseModal: () => void; fnToSetDomain: (arg0: Domain) => void; fnToOpenModal: () => void; isModelOpen: boolean; }) => {
    const appContext = useContext(AppContext);
    const [loadingDomain, setLoadingDomain] = useState(false);
    const [domainList, setDomainList] = useState([] as Domain[]);

    const domainCodeSearch = async (event: any) => {
        event.preventDefault();
        const { value } = event.target;
        if (value && value.length === 6) {
            await updateDomain(value)
            setLoadingDomain(false);
        }
    }

    const closeModal = () => {
        props.CloseModal();
    }

    const updateDomain = async (domain: string) => {
        setLoadingDomain(true);
        const dr = await getDomain(domain);
        if (dr && dr.data && dr.data.status !== 'error') {
            const domainResult = dr.data.results as Domain;
            if (!domainList.some(f => f.Code === domainResult.Code )){
                domainList.push(domainResult);
                setDomainList(domainList);
            }
            setCurentDomain(domainResult);
            setDomainStorage(domainResult);
            return domainResult;
        }
        setLoadingDomain(false);
    }


    const setCurentDomain = (doamin: Domain) => {
        appContext.setDomain(doamin);
    }
    const setDomainFromModal = (domain: Domain) => {
        appContext.setDomain(domain);
        props.CloseModal();
    }

    const deleteDomain = async (domain: Domain) => {
        const newDomainList = domainList.filter(f => f.Code !== domain.Code);
        await updateDomainStorage(newDomainList);
        setDomainList(newDomainList);
    }

    useEffect(() => {

        const fetchData = async () => {
          if (domainList.length === 0){
            const result = await  getDomainStorage();
            setDomainList(result);
          }  
        };
     
        fetchData();
      }, [domainList.length]);

    return (

        <IonModal key="DOMAIN_MODAL" swipeToClose={false} onDidDismiss={() => props.CloseModal()} isOpen={props.isModelOpen}>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonTitle className="ion-text-center">Domain Search</IonTitle>
                    <IonButtons slot="end">
                        {domainList.length > 0 && (
                            <IonButton size="small" onClick={(event) => { closeModal(); event.stopPropagation() }}>
                                <IonIcon slot="icon-only" icon={closeCircleOutline} />
                            </IonButton>
                        )}
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonItem lines="full">
                    <IonSearchbar placeholder="Search for Domain Code" onIonChange={e => domainCodeSearch(e)} debounce={300}></IonSearchbar>
                    {loadingDomain && (<IonSpinner name="lines" />)}
                </IonItem>
                <IonCard>
                    <IonItemDivider color="primary" className="item-header">
                        <IonLabel>Codes Entered</IonLabel>
                    </IonItemDivider>
                    {domainList && domainList.length > 0 &&
                        (
                            domainList.map(f => {
                                return (
                                    <IonItemSliding key={f.Code}>
                                        <IonItem button detail onClick={() => setDomainFromModal(f)} lines="full">
                                            <IonLabel>{f.Name}</IonLabel>
                                        </IonItem>
                                        <IonItemOptions side="end">
                                            <IonItemOption color="danger" onClick={() => deleteDomain(f)}>Delete</IonItemOption>
                                        </IonItemOptions>
                                    </IonItemSliding>
                                );
                            })
                        )
                    }
                </IonCard>
            </IonContent>
        </IonModal>
    )
}

export default DomainCode